/* global window */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// actions
import { addProduct } from '../../actions/orders';
import { getEvents } from '../../actions/cardEvents';

// components
import CardTitlePart from '../../parts/CardTitlePart';
import VideoPart from '../../parts/VideoPart/';
import ImagePart from '../../parts/ImagePart';
import GhostButton from '../../parts/GhostButton';
import HtmlPart from '../../parts/HtmlPart';
import OverlayLoader from '../../parts/OverlayLoader';
import SuccessConfirmationOverlay from '../../parts/SuccessConfirmationOverlay';
import FailureOverlay from '../../parts/FailureOverlay';

import { gtmCardEvent, gtmSimplePageLoadEvent } from '../../services/gtmService';

const SMALL_VAN_CAT_NO = '486-67117';
const SOFA_RESCUE_CAT_NO = '486-79782';

class _AddProductCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loadState: false
    };
    if (props.parentCardName && props.parentCardName === 'DeliveryFlow') {
      gtmSimplePageLoadEvent(`${props.parentCardName} page ${props.thisCardName}`);
    }
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleAddProduct = this.handleAddProduct.bind(this);
    this.handleDismissCard = this.handleDismissCard.bind(this);
  }

  handleSuccess(res) {
    this.setState({ loadState: 'success' });
    return res;
  }

  handleError() {
    this.setState({ loadState: 'failure' });
    window.setTimeout(() => {
      this.setState({ loadState: false });
    }, 5000);
  }

  handleAddProduct() {
    const { id, orderIdx, lineType, name, quantity, addProduct, getEvents,
      price, catalogueNumber, groupId, pushQueue, queueMessage } = this.props;

    // can change this once seven stars pick up what value adds actually are
    if (catalogueNumber === SMALL_VAN_CAT_NO) gtmCardEvent('book-delivery', 'click-yes', 'small-truck')();

    this.setState({ loadState: 'loading' });
    addProduct(id, orderIdx, lineType, name, quantity,
      price, catalogueNumber, groupId, pushQueue, queueMessage)
      .then(this.handleSuccess, () => this.setState({ loadState: false }))
      .then((res) => {
        if (res.data.Result !== true) {
          return Promise.reject();
        }
        getEvents();
        return res.data;
      }).catch(() => {
        this.handleError();
      });
  }

  handleDismissCard() {
    const { id, orderIdx, lineType, name, quantity, addProduct, getEvents,
      price, catalogueNumber, groupId, pushQueue, queueMessage } = this.props;
    // can change this once seven stars pick up what value adds actually are
    if (this.props.catalogueNumber === SMALL_VAN_CAT_NO) gtmCardEvent('book-delivery', 'click-yno', 'small-truck')();
    const cardsToTakeWithMe = this.props.catalogueNumber === SOFA_RESCUE_CAT_NO ? 'SofaRescueBookingCard' : ''
    this.setState({ loadState: 'loading' });
    this.props.dismissCard(cardsToTakeWithMe)
      .then(getEvents)
      .catch(() => {
        this.handleError();
      });
  }

  render() {
    const { title, headerImage, headerImageAltText, bodyText, headerVideo,
      price, confirmText, dismissText, orderRef, orderNo } = this.props;
    return (
      <div>
        <CardTitlePart title={title} />
        {
          headerVideo ?
            <VideoPart
              videoUrl={headerVideo}
              fallbackImage={headerImage}
              fallBackAlt={headerImageAltText}
              autoplay
            /> :
            <ImagePart url={headerImage} alt={headerImageAltText} />
        }

        <div
          className="c-event-feed__card__splitter u-padding-x-tiny u-flex u-flex-justify-space-between"
        >

          <OverlayLoader active={this.state.loadState === 'loading'} scale={0.5} background="rgba(255, 255, 255, 0.8)" />

          {this.state.loadState === 'success' ? <SuccessConfirmationOverlay /> : null}
          {this.state.loadState === 'failure' ? <FailureOverlay alpha={1} /> : null}

          <div className="left-text u-padding-x-tiny"><strong>Only £{price}</strong></div>

          <div className="u-text-nowrap">
            <GhostButton
              text={dismissText}
              position={'right'}
              align={'right'}
              type={'confirm'}
              onBtnClick={this.handleDismissCard}
              extraClass={'c-btn c-btn--ghost u-text-nowrap u-margin-right-micro'}
              disabled={this.state.loadState}
            />

            <GhostButton
              text={confirmText}
              position={'right'}
              align={'right'}
              type={'confirm'}
              loading={this.state.loadState === 'loading'}
              onBtnClick={this.handleAddProduct}
              extraClass={'c-btn c-btn--ghost u-margin-left-micro u-text-nowrap'}
              disabled={this.state.loadState}
            />
          </div>


        </div>

        {
          bodyText ?
            <div className="u-padding-x-medium u-padding-top-small">
              <HtmlPart htmlString={bodyText} />
            </div> : null
        }

        <div className="u-padding-tiny u-padding-y-small u-text-center c-event-feed__card__extra-info">
          <strong>Order Number:</strong> {`${orderRef}/${orderNo}`}
        </div>

      </div>
    );
  }

}

const mapDispatchToProps = dispatch => bindActionCreators({ addProduct, getEvents }, dispatch);

export default connect(null, mapDispatchToProps)(_AddProductCard);



// WEBPACK FOOTER //
// ./src/cards/templates/AddProductCard.js